module.exports = __webpack_public_path__ + "img/settings-icon.7e1c708e.svg";